var $89fbbdbcfc71305c$exports = {};
// logga ut-knapp
const $89fbbdbcfc71305c$var$logOutBtnEl = document.getElementById("logoutbtn");
$89fbbdbcfc71305c$var$logOutBtnEl.addEventListener("click", $89fbbdbcfc71305c$var$logout);
function $89fbbdbcfc71305c$var$logout() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    window.location.href = "index.html";
}
const $89fbbdbcfc71305c$var$url = "https://pizzaapi-kzs1.onrender.com/menu" //URL till mitt API
;
const $89fbbdbcfc71305c$var$registerFormEl = document.getElementById("registerForm");
const $89fbbdbcfc71305c$var$updateFormEl = document.getElementById("updateForm");
/* funktion för att läsa in datan i formuläret */ const $89fbbdbcfc71305c$var$registerBtnEl = document.getElementById("registerBtn");
$89fbbdbcfc71305c$var$registerBtnEl.addEventListener("click", (e)=>{
    e.preventDefault();
    let foodname = document.getElementById("foodname").value;
    let price = document.getElementById("price").value;
    let ingredients = document.getElementById("ingredients").value;
    $89fbbdbcfc71305c$var$createFoodItem(foodname, price, ingredients);
});
/* Funktion för att lägga till data i databasen */ async function $89fbbdbcfc71305c$var$createFoodItem(foodname, price, ingredients) {
    let foodItem = {
        foodname: foodname,
        price: price,
        ingredients: ingredients
    };
    let status = document.getElementById("status");
    const token = localStorage.getItem("token");
    const response = await fetch($89fbbdbcfc71305c$var$url + "/register", {
        method: "POST",
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "Application/json"
        },
        body: JSON.stringify(foodItem)
    });
    const data = await response.json();
    console.log(data);
    if (data.error) status.innerHTML = `${data.error}`;
    else {
        status.innerHTML = `${data.message}`;
        setTimeout(function() {
            location.reload();
        }, 2000);
    }
}
/* Hämta all mat på menyn och lägg den i dropdownmenyn */ window.onload = $89fbbdbcfc71305c$var$init;
async function $89fbbdbcfc71305c$var$init() {
    const optionsEl = document.getElementById("options");
    const response = await fetch($89fbbdbcfc71305c$var$url + "/getmenu");
    const data = await response.json();
    data.forEach((e)=>{
        const option = document.createElement("option");
        option.setAttribute("value", `${e.foodname}`);
        option.innerHTML = `${e.foodname}`;
        optionsEl.appendChild(option);
    });
    optionsEl.addEventListener("change", (event)=>{
        const selectedFoodname = event.target.value;
        if (selectedFoodname === "create") {
            $89fbbdbcfc71305c$var$registerFormEl.classList.remove("hidden");
            $89fbbdbcfc71305c$var$updateFormEl.classList.add("hidden");
        } else {
            $89fbbdbcfc71305c$var$updateFormEl.classList.remove("hidden");
            $89fbbdbcfc71305c$var$registerFormEl.classList.add("hidden");
            $89fbbdbcfc71305c$var$editFood(selectedFoodname);
        }
    });
}
async function $89fbbdbcfc71305c$var$editFood(foodname) {
    console.log(foodname);
    const response = await fetch($89fbbdbcfc71305c$var$url + "/getmenu/" + foodname);
    const data = await response.json();
    const nameEl = document.getElementById("updatedFoodname");
    const priceEl = document.getElementById("updatedPrice");
    const ingredientsEl = document.getElementById("updatedIngredients");
    //Läs ut datan som ska uppdateras
    nameEl.setAttribute("value", `${foodname}`);
    priceEl.setAttribute("value", `${data.price}`);
    ingredientsEl.setAttribute("value", `${data.ingredients}`);
}
//uppdatera-knappen
const $89fbbdbcfc71305c$var$updateBtnEl = document.getElementById("updateBtn");
$89fbbdbcfc71305c$var$updateBtnEl.addEventListener("click", $89fbbdbcfc71305c$var$updateFood);
//delete-knappen
const $89fbbdbcfc71305c$var$deleteBtnEl = document.getElementById("deleteBtn");
$89fbbdbcfc71305c$var$deleteBtnEl.addEventListener("click", $89fbbdbcfc71305c$var$deleteFood);
//update-funktion
async function $89fbbdbcfc71305c$var$updateFood() {
    const nameEl = document.getElementById("updatedFoodname");
    const priceEl = document.getElementById("updatedPrice");
    const ingredientsEl = document.getElementById("updatedIngredients");
    let foodItem = {
        foodname: nameEl.value,
        price: priceEl.value,
        ingredients: ingredientsEl.value
    };
    let status = document.getElementById("updateStatus");
    const token = localStorage.getItem("token");
    const response = await fetch($89fbbdbcfc71305c$var$url + "/updatemenu/" + nameEl.value, {
        method: "PUT",
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "Application/json"
        },
        body: JSON.stringify(foodItem)
    });
    const data = await response.json();
    console.log(data);
    if (data.error) status.innerHTML = `${data.error}`;
    else {
        status.innerHTML = `${data.message}`;
        setTimeout(function() {
            location.reload();
        }, 2000);
    }
}
//delete-function
async function $89fbbdbcfc71305c$var$deleteFood() {
    const nameEl = document.getElementById("updatedFoodname");
    let foodItem = {
        foodname: nameEl.value
    };
    let status = document.getElementById("updateStatus");
    const token = localStorage.getItem("token");
    const response = await fetch($89fbbdbcfc71305c$var$url + "/deletemenu/" + nameEl.value, {
        method: "DELETE",
        headers: {
            "Authorization": "Bearer " + token,
            "Content-Type": "Application/json"
        },
        body: JSON.stringify(foodItem)
    });
    const data = await response.json();
    console.log(data);
    if (data.error) status.innerHTML = `${data.error}`;
    else {
        status.innerHTML = `${data.message}`;
        setTimeout(function() {
            location.reload();
        }, 2000);
    }
}


//# sourceMappingURL=admin.1cf7bc1f.js.map
